'use client';

import { c as _c } from "react/compiler-runtime";
import { HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode, useState } from 'react';
interface Props {
  children: ReactNode;
  enableDevtools?: boolean;
}
export function ReactQueryProvider(t0) {
  const $ = _c(8);
  const {
    children,
    enableDevtools
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] !== children) {
    t1 = <HydrationBoundary>{children}</HydrationBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== enableDevtools) {
    t2 = enableDevtools && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" position="right" />;
    $[2] = enableDevtools;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== queryClient || $[5] !== t1 || $[6] !== t2) {
    t3 = <QueryClientProvider client={queryClient}>{t1}{t2}</QueryClientProvider>;
    $[4] = queryClient;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp() {
  return new QueryClient();
}